// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import './plugins/vant.js'
import './plugins/vant.js'
import "./style/common.css"
import "./style/font/din.css"
Vue.prototype.$axios = axios

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import filters from "./common/filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
import { VueJsonp } from 'vue-jsonp'
 
Vue.use(VueJsonp)

Vue.config.productionTip = false
window.eventBus = new Vue();
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js